module.exports = __webpack_public_path__ + "img/icon-chess-active.b547d75.webp";